import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ListIcon } from 'lucide-react';
import { DateField } from '@/components/form/fields/DateField';

const StatusSection = () => {
  const { setValue, watch } = useFormContext();
  const statusId = watch('statusId', 1);

  const status = watch('status', 'Activo');
  const statusDate = watch('statusDate');
  const enablementDate = watch('enablementDate');
  const lastInspectionDate = watch('lastInspectionDate');

  const handleDateSelect = (field: string, date: Date | undefined) => {
    setValue(field, date);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Estados</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div className="form-group">
            <Label className="form-label flex items-center gap-2">
              <ListIcon size={16} />
              Estado actual
            </Label>
            <div className="mt-2">
              <Badge 
                variant={status === 'Activo' ? 'success' : 'destructive'}
                className={status === 'Activo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}
              >
                {status}
              </Badge>
            </div>
          </div>

          <div className="form-group">
            <Label className="form-label flex items-center gap-2">
              <ListIcon size={16} />
              Nuevo estado
            </Label>
            <Select value={statusId} onValueChange={(value) => setValue('statusId', Number(value))}>
              <SelectTrigger className="form-select">
                <SelectValue placeholder="Seleccionar nuevo estado"/>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">Activo</SelectItem>
                <SelectItem value="2">Cerrado</SelectItem>
                <SelectItem value="3">Baja definitiva</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <DateField 
            name="statusDate"
            label="Fecha estado"
            required
          />

          <DateField 
            name="enabledDate"
            label="Fecha de habilitación"
            minDate={new Date()}
          />

          <DateField 
            name="lastInspectionDate"
            label="Fecha Última inspección"
            maxDate={new Date()}
          />
        </div>
      </div>
    </div>
  );
};

export default StatusSection;
